module.exports = __webpack_public_path__ + "static/media/beast.aa3d12d5.png";